import React, { ReactNode } from 'react';
import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoCloseCircle, IoWarningOutline } from 'react-icons/io5';
import { MdErrorOutline } from 'react-icons/md';
import { IoInformationCircle } from "react-icons/io5";

type InfoBoxProps = {
    children: ReactNode;
    className?: string;
    title?: string;
};

const InfoBox: React.FC<InfoBoxProps> = ({ children, className = '', title }) => {
    return (

        <div className="rounded-md bg-primary-50 p-4">
            <div className="flex">
                <div className="shrink-0">
                    <IoInformationCircle aria-hidden="true" className="size-5 text-primary-400" />
                </div>
                <div className="ml-3">
                    <h3 className="text-base font-medium text-primary-800">{title}</h3>
                    <div className="mt-2 text-base text-primary-700">
                        {children}
                    </div>
                </div>
            </div>
        </div>

    );
};

export const WarningBox: React.FC<InfoBoxProps> = ({ children, className = '' }) => {
    return (
        <div className={`px-4 py-2 border border-orange-500 bg-orange-100 rounded-lg ${className}`}>
            <div className='flex flex-row space-x-2 items-start'>
                <div className='w-7 h-7'>
                    <IoWarningOutline className='h-7 w-7 text-orange-500' />
                </div>
                <div className='w-full text-orange-500'>{children}</div>
            </div>
        </div>
    );
};

export const ErrorBox: React.FC<InfoBoxProps> = ({ children, className = '' }) => {
    return (
        <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
                <div className="shrink-0">
                    <IoCloseCircle aria-hidden="true" className="size-5 text-red-400" />
                </div>
                <div className="ml-3 text-sm text-red-700">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default InfoBox;